import { useMutation, useQueryClient } from '@tanstack/react-query'
import { supabase } from '@/lib/supabase/client'
import { useUser } from '@/hooks/useAuth'
import type { Notification } from '@/types'

export function useMarkAllRead() {
  const user = useUser()
  const qc = useQueryClient()

  return useMutation({
    mutationFn: async () => {
      const { error } = await supabase
        .from('notifications')
        .update({ read_at: new Date().toISOString() })
        .eq('recipient_user_id', user!.id)
        .is('read_at', null)
      if (error) throw error
    },

    onMutate: async () => {
      await qc.cancelQueries({ queryKey: ['notifications', user?.id] })
      const prev = qc.getQueryData<Notification[]>(['notifications', user?.id])
      qc.setQueryData<Notification[]>(['notifications', user?.id], (old) =>
        (old ?? []).map((n) => ({ ...n, read_at: n.read_at ?? new Date().toISOString() })),
      )
      return { prev }
    },

    onError: (_err, _void, ctx) => {
      if (ctx?.prev) qc.setQueryData(['notifications', user?.id], ctx.prev)
    },

    onSettled: () => {
      qc.invalidateQueries({ queryKey: ['notifications', user?.id] })
    },
  })
}
